__turbopack_context__.v({
  "default": "toggle-button-module-scss-module__aNrPXW__default",
  "light": "toggle-button-module-scss-module__aNrPXW__light",
  "toggleButton": "toggle-button-module-scss-module__aNrPXW__toggleButton",
  "up": "toggle-button-module-scss-module__aNrPXW__up",
});
